import { cloneDeep, findIndex, remove } from "lodash";
import {
  ADD_DISCUSSION_FORUM,
  ADD_DISCUSSION_FOR_POST,
  ADD_DISCUSSION_POST,
  ADD_POST_COMMENT_SUCCESS,
  CREATE_POST_COMMENT_FILE_SUCCESS,
  DELETE_DISCUSSION_FOR_POST,
  DELETE_DISCUSSION_POST,
  DELETE_POST_COMMENT_SUCCESS,
  EDIT_DISCUSSION_FORUM,
  EDIT_DISCUSSION_FOR_POST,
  EDIT_DISCUSSION_POST,
  EDIT_POST_COMMENT_SUCCESS,
  GET_ALL_DISCUSSION_FORUM_SUCESS,
  GET_ALL_POST_DISCUSSION_SUCCESS,
  GET_DISCUSSION_FORUM_NAME,
  GET_DISCUSSION_POST_NAME,
  GET_FORUM_POST_SUCCESS,
  GET_SINGLE_DISCUSSION_FORUM,
  GET_SINGLE_DISCUSSION_POST,
  GET_SINGLE_FORUM,
  GET_SINGLE_POST,
  GET_SINGLE_POST_COMMENT_SUCCESS,
  RESET_DISCUSSION_DETAILS_FORUM,
  RESET_UPDATE_DISCUSSION_DETAILS,
  RESET_UPDATE_DISCUSSION_FORUM_DETAILS,
} from "../constants";

export const initialState = {
  postComment: undefined,
  postCommentDetails: undefined,
  discussionDetails: undefined,
  postDetails: undefined,
  discussionForumNameList: [],
  updateDiscussionForum: undefined,
  updateDiscussionPost: undefined,
  discussionSingleForum: undefined,
  discussionSinglePost: undefined,
  discussionPostCommentImage: undefined,
};
export const DiscussionReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SINGLE_POST_COMMENT_SUCCESS:
      return {
        ...state,
        postCommentDetails: action.payload,
      };
    case GET_SINGLE_FORUM: {
      return {
        ...state,
        discussionSingleForum: action.payload,
      };
    }
    case GET_SINGLE_POST: {
      return {
        ...state,
        discussionSinglePost: action.payload,
      };
    }
    case GET_FORUM_POST_SUCCESS: {
      return {
        ...state,
        discussionSinglePost: action.payload,
      };
    }
    case ADD_POST_COMMENT_SUCCESS:
      // const tempAddDetails = cloneDeep(state.postComment);
      // tempAddDetails.data.splice(0, 0, action.payload);
      // return {
      //   ...state,
      //   postComment: tempAddDetails,
      // };
      // const tempAddDetails = cloneDeep(state.postCommentDetails);
      // tempAddDetails.splice(0, 0, action.payload);
      return {
        ...state,
        postCommentDetails: action.payload,
      };
    case GET_DISCUSSION_FORUM_NAME: {
      return {
        ...state,
        discussionForumNameList: action.payload,
      };
    }
    case GET_DISCUSSION_POST_NAME: {
      return {
        ...state,
        discussionForumNameList: action.payload,
      };
    }
    case GET_SINGLE_DISCUSSION_FORUM: {
      return {
        ...state,
        updateDiscussionForum: action.payload,
      };
    }
    case RESET_UPDATE_DISCUSSION_DETAILS: {
      return {
        ...state,
        updateDiscussionForum: undefined,
      };
    }

    case EDIT_POST_COMMENT_SUCCESS:
      return {
        ...state,
        postCommentDetails: state.postCommentDetails.map((comment) =>
          comment._id === action.payload._id ? action.payload : comment
        ),
      };

    case GET_ALL_DISCUSSION_FORUM_SUCESS: {


      return {
        ...state,
        discussionDetails: action.payload,
      };
    }
    case ADD_DISCUSSION_FORUM: {

      const tempAddDetails = cloneDeep(state.discussionDetails);
      tempAddDetails.data.splice(0, 0, action.payload);
      return {
        ...state,
        discussionDetails: tempAddDetails,
      };
    }
    case DELETE_DISCUSSION_POST: {
      const tempDeleterDetails = cloneDeep(state.postDetails);
      remove(tempDeleterDetails, (obj) => obj._id === action.payload);
      return {
        ...state,
        postDetails: tempDeleterDetails,
      };
    }
    case EDIT_DISCUSSION_POST: {
      const tempCourseDetails = cloneDeep(state.postDetails);
      const index = findIndex(
        tempCourseDetails.data,
        (obj) => obj._id === action.payload._id
      );

      if (index !== -1) {
        tempCourseDetails.data[index] = action.payload;
      }
      return {
        ...state,
        postDetails: tempCourseDetails,
      };
    }
    case ADD_DISCUSSION_POST: {
      const tempAddDetails = cloneDeep(state.postDetails);
      tempAddDetails.data.splice(0, 0, action.payload);
      return {
        ...state,
        postDetails: tempAddDetails,
      };
    }
    case ADD_DISCUSSION_FOR_POST: {

      const tempAddDetails = cloneDeep(state?.discussionSinglePost);

      tempAddDetails?.splice(0, 0, action.payload);
      return {
        ...state,
        discussionSinglePost: tempAddDetails,
      };
    }
    case DELETE_DISCUSSION_FOR_POST: {
      const tempDeleterDetails = cloneDeep(state.discussionSinglePost);
      remove(tempDeleterDetails, (obj) => obj._id === action.payload);
      return {
        ...state,
        discussionSinglePost: tempDeleterDetails,
      };
    }
    case EDIT_DISCUSSION_FOR_POST: {
      const tempCourseDetails = cloneDeep(state.discussionSinglePost);
      const index = findIndex(
        tempCourseDetails,
        (obj) => obj._id === action.payload._id
      );

      if (index !== -1) {
        tempCourseDetails[index] = action.payload;
      }
      return {
        ...state,
        discussionSinglePost: tempCourseDetails,
      };
    }

    case EDIT_DISCUSSION_FORUM: {
      const tempCourseDetails = cloneDeep(state.discussionDetails);
      const index = findIndex(
        tempCourseDetails.data,
        (obj) => obj._id === action.payload._id
      );

      if (index !== -1) {
        tempCourseDetails.data[index] = action.payload;
      }
      return {
        ...state,
        discussionDetails: tempCourseDetails,
      };
    }

    case DELETE_POST_COMMENT_SUCCESS:
      const tempDeleterDetails = cloneDeep(state.postComment);
      remove(tempDeleterDetails.data, (obj) => obj._id === action.payload);

      const tempPostCommentDetails = cloneDeep(state.postCommentDetails);
      remove(tempPostCommentDetails.data, (obj) => obj._id === action.payload);
      return {
        ...state,
        postComment: tempDeleterDetails,
        postCommentDetails: tempPostCommentDetails
      };

    // postDetails
    case GET_ALL_POST_DISCUSSION_SUCCESS: {
      return {
        ...state,
        postDetails: action.payload,
      };
    }
    case GET_SINGLE_DISCUSSION_POST: {
      return {
        ...state,
        updateDiscussionPost: action.payload,
      };
    }
    case RESET_UPDATE_DISCUSSION_FORUM_DETAILS: {
      return {
        ...state,
        updateDiscussionPost: undefined,
      };
    }
    case CREATE_POST_COMMENT_FILE_SUCCESS: {
      return {
        ...state,
        discussionPostCommentImage: action.payload,
      };
    }
    case RESET_DISCUSSION_DETAILS_FORUM: {
      return {
        ...state,
        postDetails: undefined,
      };
    }
    default:
      return state;
  }
};
